export default "__VITE_ASSET__0e9c1ba9__"